const CMS_DATA = {
  siteSetting: {
    id: 1,
    contactRecipient: "dev@caroadhouse.samrod.com",
    welcomeCta: "Enter",
    welcomeSub: "Santa Monica Pier | Summer '26",
    welcomeHeader: "The California Roadhouse",
    footerText: "Steaks\nRibs\nBurgers\nSeafoods\nSalads\nBowls\nWraps\n\nLive Music\nKaraoke\nComedy\nTrivia\nDancing",
    shares: [
      { "id": 1, "icon": "twitter" },
      { "id": 2, "icon": "facebook" },
      { "id": 3, "icon": "linkedin" },
      { "id": 4, "icon": "email" },
      { "id": 5, "icon": "link" },
      { "id": 6, "icon": "download" }
    ],
    music: {
      id: 5,
      artist: "Prestyn Smith",
      description: "Prestyn Smith is an artist with popular singles and EPs including “Can’t Lie”, “Falling Out”, “FLICKER”, “I Meant It”, “Kitchen”, and “Angel On My Shoulder”. Their albums include Falling Out (2025), Can’t Lie (2025), I Meant It (2025), Angel On My Shoulder (2024), and Minimum Wage (2024). Some recommend their releases “Kitchen”, “Angel On My Shoulder”, “Out of Range”, “dark cherry”, “Rose Tinted”, and “Call It What You Want”.",
      volume: 3,
      youtube: {
          id: 29,
          title: "Prestyn Smith",
          vid: "ESIoCKjWQ4s",
          start: 66,
          end: 221
        }
    }
  },
  playlists: [
    {
      id: 1,
      artist: "Prestyn Smith Playlist",
      description: "Prestyn Smith is an artist with popular singles and EPs including \"Can't Lie\", \"Falling Out\", \"FLICKER\", \"I Meant It\", \"Kitchen\", and \"Angel On My Shoulder\". Their albums include Falling Out (2025), Can't Lie (2025), I Meant It (2025), Angel On My Shoulder (2024), and Minimum Wage (2024). Some recommend their releases \"Kitchen\", \"Angel On My Shoulder\", \"Out of Range\", \"dark cherry\", \"Rose Tinted\", and \"Call It What You Want\".",
      promoLink: "https://www.instagram.com/prestynsmithmusic/",
      youtube: {
        id: 29,
        title: "Prestyn Smith",
        vid: "ESIoCKjWQ4s",
        start: 66,
        end: 221,
        volume: 3
      }
    },
    {
      id: 2,
      artist: "The & Joey",
      description: "In the vein of the blues, with an upbeat vibe, inspired by the soul of BB King, the solo voicing of Carlos Santana, and the lyricism of Frank Sinatra, Los Angeles presents The & Joey. Join our Upbeat Blues Rock atmosphere - salute!",
      promoLink: "https://thebandjoey.com/",
      youtube: {
        title: "The & Joey",
        vid: "_yKrcuhSzOg",
        start: 1,
        end: null
      }
    },
    {
      id: 3,
      artist: "Sophie Powers",
      description: "Rising avant-pop force Sophie Powers is back and bolder than ever with her latest single, \"move with me.\" Marking the dawn of a new era, the 20-year-old artist sheds the bubblegum neon aesthetic that defined her earlier work, stepping into a darker, rawer, and more nihilistic vision that embraces chaos rather than sugarcoating it.",
      promoLink: "https://sophiepowers.komi.io/",
      youtube: {
        title: "Sophie Powers",
        vid: "es9-YEgzcVI",
        start: 0,
        end: null
      }
    },
    {
      id: 4,
      artist: "Anna Duboc",
      description: "\"From Stage Lights to Streaming charts. She's not just a rising star-- she's a whole universe of talent.\" -- LA Feature Magazine",
      promoLink: "https://annaduboc.com/",
      youtube: {
        title: "Anna Duboc",
        vid: "ATCLDaOnvJM",
        start: 0,
        end: null
      }
    },
    {
      id: 5,
      artist: "Jack & Daisy",
      description: "Jack & Daisy are the British indie-folk duo making quiet waves with their warm harmonies and poetic songwriting. Over the last eight years, they've played more than 1,000 shows across the UK and Europe, gracing everything from candlelit cafés to major festival stages.",
      promoLink: "https://jackanddaisy.songbits.com",
      youtube: {
        title: "Jack & Daisy",
        vid: "174ru4WvSAI",
        start: 0,
        end: null
      }
    },
    {
      id: 6,
      artist: "Karolina Protsenko",
      description: "I’m Karolina Protsenko, a violinist who believes that music can touch hearts and change lives. Enjoy violin covers, live performances, and moments of pure emotion.",
      promoLink: "https://www.instagram.com/karolina_protsenko/",
      youtube: {
        title: "Karolina Protsenko",
        vid: "hhVJ-mLxMkA",
        start: 0,
        end: null
      }
    },
    {
      id: 7,
      artist: "Elle & Toni",
      description: "Elle and Toni are indie folk musicians who write and cover americana, folk, traditional folk, and folk rock music",
      promoLink: "https://www.youtube.com/channel/UC42GLYQ9Q9z4pEX1anQ9Lzg",
      youtube: {
        title: "Elle & Toni",
        vid: "3xBdRDrLc3o",
        start: 18,
        end: null
      }
    },
    {
      id: 8,
      artist: "Dani Hagan",
      description: "Dani Hagan has become a standout voice in LA's rock scene, known for her authentic storytelling and commanding performances. With a unique blend of grungy guitar riffs, emotive lyrics, and powerhouse vocals, her music captures the intensity of life’s highs and lows, often exploring themes of love, vulnerability, and self-discovery.",
      promoLink: "https://www.danihagan.com",
      youtube: {
        title: "Dani Hagan",
        vid: "6Cx9ljzpkyU",
        start: 0,
        end: null
      }
    },
    {
      id: 9,
      artist: "Nene Royal",
      description: "13 year old Thai girl based on Phuket / Thailand performing cover versions of different styles international songs (vocals & guitar). Her guitar skills amazes even professionals ..... fingers faster than light!",
      promoLink: "https://neneroyal.com",
      youtube: {
        title: "Nene Royal",
        vid: "u0wjRuAVtxs",
        start: 0,
        end: null
      }
    },
    {
      id: 10,
      artist: "The Pushing Flowers",
      description: "The Pushing Flowers are a music project based in Silver Spring, Maryland, centered around original songs released on platforms like Bandcamp, led by musician John Manzo with a 2025 album release under their name.",
      promoLink: "https://www.instagram.com/thepushingflowers/",
      youtube: {
        title: "The Pushing Flowers",
        vid: "W_tQmdQ8goc",
        start: 0,
        end: null
      }
    },
    {
      id: 11,
      artist: "Sophie Lloyd",
      description: "I've been playing guitar since I was 9 years old! I graduated from university in 2018 completing a BMus Popular Music Performance course and managed to get a First Class Honours degree! During that time, I released my First EP – Delusions, toured the UK playing live music and continued to provide monthly videos of shred covers and original music!",
      promoLink: "https://www.sophieguitar.com/",
      youtube: {
        title: "Sophie Lloyd",
        vid: "VwcjsVMbsbk",
        start: 0,
        end: null
      }
    },
    {
      id: 12,
      artist: "Ladyva",
      description: "Pianist, composer, boogie-woogie, Blues, Jazz",
      promoLink: "https://ladyva.com/",
      youtube: {
        title: "Ladyva",
        vid: "fFeJhjmXyAM",
        start: 0,
        end: null
      }
    }
  ],
  youtubePlayer: [
    {
      id: 29,
      title: "Prestyn Smith",
      vid: "ESIoCKjWQ4s",
      start: 66,
      end: 221,
      volume: 3
    },
    {
      id: 40,
      title: "George Michael",
      vid: "diYAc7gB-0A",
      start: 14,
      end: null,
      volume: 3
    },
    {
      id: 3,
      title: "Weird Al",
      vid: "8Gv0H-vPoDc",
      start: 0,
      end: null,
      volume: 3
    }
  ],
  homepage: {
    id: 1,
    title: "California Roadhouse",
    cta: "Join our Team",
    bullets: [
      { "id": 1, "text": "The California Roadhouse" },
      { "id": 2, "text": "Classic American Dining" },
      { "id": 3, "text": "Healthy Smoothies, Wraps, Build Your Own Burgers" },
      { "id": 4, "text": "Live Entertainment" },
      { "id": 5, "text": "Craft Cocktails, California Beers" },
      { "id": 6, "text": "Coming to the Santa Monica Pier in 2026" }
    ],
    video: {
      id: 1,
      title: "SM Pier Drone Shots",
      vid: "ERU3GrVoVuI",
      start: 0,
      end: 39.5
    }
  },
  navs: [
    { "id": 3, "label": "Home", "href": "/", "enabled": true, "order": 0 },
    {
      id: 16,
      label: "Artists",
      href: "/artists",
      enabled: true,
      order: 1
    },
    {
      id: 7,
      label: "Newsroom",
      href: "/news",
      enabled: true,
      order: 2
    },
    {
      id: 5,
      label: "Careers",
      href: "/apply",
      enabled: true,
      order: 4
    }
  ],
  newsArticles: [
    {
      id: 1,
      title: "Historic Santa Monica Pier Building to Become Route 66–Inspired California Roadhouse",
      date: "2026-01-08",
      url: "https://smmirror.com/2026/01/historic-santa-monica-pier-building-to-become-route-66-inspired-california-roadhouse/",
      caption: "New Dining and Entertainment Venue Led by Local Restaurateur Sean Ahaus Is Slated to Open in Spring",
      hero: "https://smmirror.com/wp-content/uploads/2026/01/Santa-Monica-Pier-Building-to-Become-Route-66%E2%80%93Inspired-California-Roadhouse.png",
      logo: "https://smmirror.com/wp-content/uploads/2020/06/cropped-Santa-Monica-Mirror.png",
      publication: "SMM"
    },
    {
      id: 3,
      title: "New Restaurant to Replace Rusty's on Santa Monica Pier",
      date: "2025-11-23",
      author: "Matthew Hall",
      url: "https://www.smdp.com/new-restaurant-to-replace-rustys-on-santa-monica-pier/",
      caption: "The Santa Monica Pier marks the symbolic end of the road for Historic Route 66 but proprietors of The California Roadhouse, a new restaurant and entertainment venue replacing the recently closed Rusty's Surf Ranch hope they can keep the party going with the preservation of live music over the Pacific Ocean.",
      hero: "https://www.smdp.com/content/images/size/w960/format/webp/smdp-com/wp-content/uploads/sites/21/2024/09/unnamed-12.webp",
      logo: "https://www.smdp.com/content/images/size/w320/format/webp/2025/07/SMDP-new-logo-300x128-1-1.webp",
      publication: "SMDP"
    }
  ],
  pressReleases: [
    {
      id: 1,
      title: "California Roadhouse to Launch on the Santa Monica Pier",
      slug: "launch",
      date: "2025-07-26",
      body: "California Roadhouse is making a proposal to open a new family-friendly, all-ages, live music & entertainment concept to be located at 256 Santa Monica Pier.\n\nCalifornia Roadhouse objectives:…",
      location: "Santa Monica, CA",
      releaseStatus: "published"
    }
  ],
  contactForm: {
    id: 1,
    successMessage: "Thank you — Your application to the California Roadhouse was sent successfully.",
    submitButtonText: "Send Application",
    resumeFieldText: "drag or upload resume",
    activeStatusText: "Sending…",
    agreementLabel: "I agree to the California Roadhouse Core Values",
    applicationTerms: `<h3>CALIFORNIA ROADHOUSE, INC.</h3>
<h4>OUR CORE VALUES</h4>
 
<h5>HOSPITALITY FIRST — INCLUSIVE AND RESPECTFUL</h5>
 
Every guest, performer and team member matters. Every team member belongs. Everyone is respected.
 
We strive to create an environment where each guest, performer, team member and vendor feels welcome, included, and respected—regardless of background, identity, appearance, or beliefs. Where respect and inclusivity are demonstrated through our words, actions, and service standards.

We provide warm, friendly, attentive, judgment-free service; use respectful language and behavior; accommodate reasonable needs; and maintain a workplace where individuals will be treated with dignity, fairness, and professionalism.
 
<ht>QUALITY WITHOUT COMPROMISE</ht>
We are proud to serve the highest-quality foods and beverages.
From the highest-quality ingredients, to preparation, presentation and service, we follow our standards, respect our recipes and specifications, and never cut corners.
 
<ht>INTEGRITY IN EVERYTHING WE DO</ht>
We do the right thing - even when no one is watching.
Honesty, quality work, ethical behavior, professionalism, everyone's safety and respect for the law are non-negotiable.
 
<ht>TEAMWORK & RESPECT</ht>
A great company and work environment is built together with great team members.
We support one another, listen attentively, communicate clearly, and treat every role with mutual respect, professionalism, and with a sincere dedication to teamwork. A positive workplace attitude is essential – Our team members are committed to expressing kindness, with upbeat, positive energy and to working together to make each day better for everyone.
 
<ht>OPERATIONAL DISCIPLINE</ht>
Trust is built with consistency.
We follow procedures, manage costs responsibly, and hold ourselves accountable to high standards—every shift, every day. We understand our success depends on us maintaining high standards while managing costs responsibly.
 
<ht>COMMUNITY CONNECTION</ht>
We are proud to serve our community, while we respect our neighbors, team members, guests, performers, and vendors. We strive to be a positive presence in every interaction.
 
<ht>GROWTH WITH PURPOSE</ht>
We’re committed to protecting our company’s values, integrity, culture & standards as we grow together.
 
These values guide us in how we work, how we serve, and how we succeed - together.
 
If you align with these values, we welcome you to apply to join our team.
 
- Sean Ahaus, Head of Talent @ California Roadhouse, Inc.`,
    title: "Join our Team"
  },
  artistsPage: {
    id: 1,
    header: "Showcase Your Sound",
    subHeade: "Featured Artists",
    description: "We're excited to open our stage to local performers. We're looking for bands and solo acts who bring energy, community, and a love for classic American music.",
    submissionLink: "Learn About Submissions",
    submissionHeader: "Artist Submissions",
    submissionText: "We're excited to open our stage to local performers. We're looking for bands and solo acts who bring energy, community, and a love for classic American music.",
    returnLink: "Return to Artists",
  }
};

export default CMS_DATA;
